/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useState } from 'react'
import { useParams, useLocation, useNavigate, Link } from 'react-router-dom'
import { viewData } from '../user-list/core/_requests'
import { Popover, OverlayTrigger } from 'react-bootstrap'

export function UserPlan() {
  const { id } = useParams()
  const [data, setData] = useState<any>([])
  useEffect(() => {
    viewData(id).then((res: any) => {
      setData(res.data[0])
    })
  }, [])
  // Helper function to format dates
  const formatDate = (date: string) => {
    return new Date(date).toLocaleDateString()
  }
  return (
    <>
      <div className='tab-content' id='myTabContent'>
        <div className='mb-xl-10 tab-pane fade active show' id='kt_tab_overview' role='tabpanel'>
          <div className='card mb-5 mb-xl-10'>
            <div className='card-header cursor-pointer'>
              <div className='card-title row m-0 w-100'>
                <div className='col'>
                  <h3 className='fw-bolder m-0'>User Plans</h3>
                </div>
                <div className='col-auto'>
                  <Link to={`/users/upgrade/${id}`} className='btn btn-primary'>
                    Activate Plan
                  </Link>
                </div>
              </div>
            </div>

            <div className='card-body'>
              <div className='table-responsive'>
                {/* begin::Table */}
                <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                  {/* begin::Table head */}
                  <thead>
                    <tr className='fw-bold text-muted'>
                      <th className='min-w-340px'> Plan</th>
                      <th className='min-w-340px'> Amount</th>
                      <th className='min-w-340px'> Days</th>
                      <th className='min-w-100px'>Category</th>
                      <th className='min-w-100px'>Coupon</th>
                      <th className='min-w-100px'>Start Date</th>
                      <th className='min-w-100px'>End Date</th>
                      <th className='min-w-100px'>Expired</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.user_plan_details?.length > 0 ? (
                      data.user_plan_details.map((plan: any, index: number) => (
                        <tr key={index}>
                          <td>{plan.planName}</td>
                          <td>{plan.amount}</td>
                          <td>{plan.days}</td>
                          <td>{plan.planCategoryName}</td>
                          <td>{plan.coupon ? (
                            <OverlayTrigger
                              trigger='click'
                              placement='top'
                              overlay={
                                <Popover id={`popover-${index}`}>
                                  <Popover.Header as="h3">Coupon Details</Popover.Header>
                                  <Popover.Body>
                                    <strong>Code:</strong> {plan.coupon} <br />
                                    <strong>Type:</strong> {Number(plan.coupon_type) === 2 ? 'Plan Specific' : 'Common'} <br />
                                    <strong>Discount:</strong> {plan.coupon_discount_value} {Number(plan.coupon_discount_type) === 1 ? '%' : 'Fixed'}
                                  </Popover.Body>
                                </Popover>
                              }
                            >
                              <span className='badge badge-info cursor-pointer' style={{ cursor: 'pointer' }}>{plan.coupon}</span>
                            </OverlayTrigger>
                          ) : '-'}</td>
                          <td>{formatDate(plan.startDate)}</td>
                          <td>{formatDate(plan.endDate)}</td>
                          <td>
                            {plan.status === 0 ? (
                              <span className='badge badge-secondary'>Inactive</span>
                            ) : plan.isExpired ? (
                              <span className='badge badge-danger'>Expired</span>
                            ) : (
                              <span className='badge badge-success'>Active</span>
                            )}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={8} className='text-center fw-bold'>
                          No records found
                        </td>{' '}
                        {/* Ensure the message spans all columns */}
                      </tr>
                    )}
                  </tbody>

                  {/* end::Table body */}
                </table>

                {/* end::Table */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
